import { Button, FlexBox, Text } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'

import badge from '../../lib/assets/icons/fable-premium-lock-badge.webp'
import { showPlusUpsell } from '../../lib/utils'
import { CompChildren } from 'types'
import { useStatsTheme } from '../../theme/ctx'

interface Props {
  className?: string
  title?: string
  description: string
  textFluidWidth?: string
  image?: {
    src: string
    alt: string
    styles?: string
  }
  imageEl?: CompChildren
  onClick?: () => void
}

export const StatsUpsellCard = ({
  className = '',
  title = 'Unlock more charts',
  textFluidWidth = '',
  description,
  image,
  imageEl,
  onClick,
}: Props) => {
  const theme = useStatsTheme((s) => s.theme)
  const { mediaQueries } = useTheme()
  const cardTitle = title
  const buttonText = 'Try Fable Plus'

  const handleOnClick = () => {
    onClick?.()
    showPlusUpsell()
  }

  return (
    <FlexBox
      className={cx(
        css`
          width: 100%;
          padding: 0 20px;
          position: relative;
        `,
        className
      )}
    >
      <span
        className={css`
          display: block;
          width: calc(100% - 40px);
          height: 100%;
          background-color: ${theme.colors.section.bg};
          border-radius: 24px;
          position: absolute;
          top: 0;
          left: 20px;
          opacity: 0.7;
        `}
      />
      <FlexBox
        className={css`
          width: 100%;
          padding: 16px;
          position: relative;
          z-index: 1;
        `}
        onClick={handleOnClick}
        flexDirection="column"
      >
        <img
          className={css`
            display: block;
            width: 29px;
          `}
          src={badge}
          alt="fable-lock-badge"
        />
        <FlexBox
          className={css`
            margin: 12px 0 20px;
            width: 100%;
            max-width: 150px;
            gap: 2px;
            max-width: 120px;
            ${mediaQueries.mobileXS} {
              max-width: 130px;
            }
            ${mediaQueries.mobileS} {
              max-width: ${textFluidWidth || '50%'};
            }
            ${mediaQueries.mobileL} {
              max-width: 150px;
            }
          `}
          flexDirection="column"
        >
          <Text
            type="subhead"
            tag="h4"
            className={css`
              font-size: 14px;
              line-height: 16px;
              letter-spacing: -0.2px;
            `}
            color={theme.colors.section.text}
          >
            {cardTitle}
          </Text>
          <Text
            type="body"
            tag="p"
            className={css`
              font-size: 12px;
              line-height: 16px;
              letter-spacing: -0.2px;
            `}
            weight="500"
            color={theme.colors.section.textSecondary}
          >
            {description}
          </Text>
        </FlexBox>
        <Button
          className={css`
            width: 100%;
            max-width: 120px;
            height: 40px;
            font-size: 12px;
            line-height: 12px;
            background-color: ${theme.colors.upsellBtnBg};
            border-color: ${theme.colors.upsellBtnBg};
            color: ${theme.colors.upsellBtnText};
            &:hover {
              background-color: ${theme.colors.upsellBtnBg};
              border-color: ${theme.colors.upsellBtnBg};
              color: ${theme.colors.upsellBtnText};
            }
          `}
        >
          {buttonText}
        </Button>
      </FlexBox>
      {imageEl ? (
        imageEl
      ) : (
        <img
          className={cx(
            css`
              display: block;
              width: 45%;
              max-width: 190px;
              position: absolute;
              top: 51%;
              right: 24px;
              transform: translateY(-50%);
            `,
            image?.styles
          )}
          src={image?.src || ''}
          alt={image?.alt || ''}
        />
      )}
    </FlexBox>
  )
}
